import React from "react";

export const globalImpact = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_33705_1705)">
        <path
          d="M14.9818 6.78774C13.6843 5.42375 12.3903 4.71207 12.3359 4.68246L11.9999 4.49963L11.664 4.68246C11.6096 4.71207 10.3157 5.42375 9.01806 6.78774C7.27375 8.62126 6.35179 10.7712 6.35179 13.0053C6.35179 16.1197 8.88556 18.6534 11.9999 18.6534C15.1143 18.6534 17.6481 16.1196 17.6481 13.0053C17.6481 10.7712 16.7261 8.62126 14.9818 6.78774ZM11.2972 13.5069L8.06255 10.9885C8.26023 10.351 8.55368 9.73172 8.94216 9.13291L11.2971 10.9665V13.5069H11.2972ZM12.7028 10.9665L15.0539 9.13596C15.4105 9.68763 15.7203 10.3068 15.9341 10.9911L12.7028 13.507V10.9665ZM14.2012 8.01838L12.7028 9.18506V6.62314C13.1475 6.96701 13.6829 7.4341 14.2012 8.01838ZM11.2972 6.62304V9.18506L9.7973 8.0173C9.8659 7.94018 9.93567 7.86334 10.0077 7.78701C10.4579 7.30998 10.9112 6.9209 11.2972 6.62304ZM7.75748 13.0052C7.75748 12.8508 7.7631 12.6974 7.77332 12.5447L11.2972 15.2884V17.1892C9.29118 16.8533 7.75748 15.1052 7.75748 13.0052ZM12.7028 17.1892V15.2884L16.2263 12.545C16.2366 12.6961 16.2425 12.8493 16.2425 13.0052C16.2425 15.1052 14.7088 16.8533 12.7028 17.1892Z"
          fill="currentColor"
        />
        <path
          d="M6.70541 21.1705C4.25589 19.7562 2.50371 17.4727 1.77165 14.7406C0.662454 10.601 2.17043 6.24293 5.4691 3.66062L5.13104 6.41366L6.52623 6.58497L7.13717 1.6089L2.1611 0.997864L1.9898 2.39301L4.42897 2.69251C0.81328 5.63353 -0.822842 10.489 0.413843 15.1045C1.24308 18.1992 3.22789 20.7858 6.00254 22.3878C7.85087 23.4549 9.90189 24 11.9804 24C13.0221 24 14.0712 23.8629 15.1045 23.5861L14.7406 22.2284C12.0086 22.9604 9.15497 22.5847 6.70541 21.1705Z"
          fill="currentColor"
        />
        <path
          d="M23.5861 8.8955C22.7569 5.80075 20.7721 3.21413 17.9974 1.61217C15.2227 0.0102018 11.9902 -0.41538 8.89549 0.413902L9.25937 1.77166C11.9914 1.03955 14.845 1.41533 17.2946 2.8295C19.7441 4.24376 21.4963 6.52723 22.2283 9.25933C23.3375 13.3989 21.8296 17.7571 18.5309 20.3394L18.869 17.5863L17.4738 17.415L16.8628 22.3911L21.8389 23.0021L22.0102 21.607L19.571 21.3075C23.1867 18.3664 24.8228 13.511 23.5861 8.8955Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_33705_1705">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
